import _implicitStylesheets from "./helpCenterMobile.css";
import _implicitScopedStylesheets from "./helpCenterMobile.scoped.css?scoped=true";
import _wdsLink from "wds/link";
import _axIcon from "ax/icon";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<h4 class="help-center-title${0}" type-style="display-7"${2}>${"t1"}</h4>`;
const $fragment2 = parseFragment`<h3 class="news-title${0}" type-style="display-8"${2}>${"t1"}</h3>`;
const $fragment3 = parseFragment`<h5 class="news-title${0}" type-style="display-8"${2}>${"t1"}</h5>`;
const $fragment4 = parseFragment`<h3 class="news-title${0}" type-style="display-8"${2}>${"t1"}</h3>`;
const $fragment5 = parseFragment`<h5 class="news-title${0}" type-style="display-8"${2}>${"t1"}</h5>`;
const $fragment6 = parseFragment`<h3 class="help-questions-title${0}" type-style="display-8"${2}>${"t1"}</h3>`;
const $fragment7 = parseFragment`<h4 class="help-questions-title${0}" type-style="display-8"${2}>${"t1"}</h4>`;
const $fragment8 = parseFragment`<a href="https://help.salesforce.com/s/" target="_blank" rel="noopener noreferrer"${3}><span class="help-questions-text${0}" type-style="body-3"${2}>${"t2"}</span></a>`;
const $fragment9 = parseFragment`<a href="https://www.surveymonkey.com/r/PLPJ3WD" target="_blank" rel="noopener noreferrer"${3}><span class="help-questions-text${0}" type-style="body-3"${2}>${"t2"}</span></a>`;
const stc0 = {
  "news-card": true
};
const stc1 = {
  "data-testid": "news"
};
const stc2 = {
  "news-text": true
};
const stc3 = {
  "data-testid": "jp-news"
};
const stc4 = {
  key: 19
};
const stc5 = {
  classMap: {
    "help-questions-card": true
  },
  key: 20
};
const stc6 = {
  classMap: {
    "help-questions-icon": true
  },
  props: {
    "icon": "support",
    "theme": "blue",
    "size": "small",
    "spriteUrl": "/images/icons.svg",
    "ariaHidden": "true"
  },
  key: 21
};
const stc7 = {
  key: 22
};
const stc8 = {
  classMap: {
    "help-questions-card": true
  },
  key: 25
};
const stc9 = {
  classMap: {
    "help-questions-icon": true
  },
  props: {
    "icon": "feedback",
    "theme": "blue",
    "size": "small",
    "spriteUrl": "/images/icons.svg",
    "ariaHidden": "true"
  },
  key: 26
};
const stc10 = {
  key: 27
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, c: api_custom_element, h: api_element, i: api_iterator, f: api_flatten} = $api;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.containerClass),
    key: 0
  }, api_flatten([!$cmp.hideTitle ? api_static_fragment($fragment1, 2, [api_static_part(1, null, api_dynamic_text($cmp.labels.title))]) : null, api_iterator($cmp.news, function (newsItem) {
    return !$cmp.isJapaneseUserLanguage ? api_element("div", {
      classMap: stc0,
      attrs: stc1,
      key: api_key(3, newsItem.iteratorKey)
    }, [$cmp.hideTitle ? api_static_fragment($fragment2, 5, [api_static_part(1, null, api_dynamic_text(newsItem.title))]) : null, !$cmp.hideTitle ? api_static_fragment($fragment3, 7, [api_static_part(1, null, api_dynamic_text(newsItem.title))]) : null, api_custom_element("wds-link", _wdsLink, {
      classMap: stc2,
      props: {
        "target": "_blank",
        "i18nMessage": newsItem.text
      },
      key: 8
    })]) : null;
  }), api_iterator($cmp.jpNews, function (jpNewsItem) {
    return $cmp.isJapaneseUserLanguage ? api_element("div", {
      classMap: stc0,
      attrs: stc3,
      key: api_key(9, jpNewsItem.iteratorKey)
    }, [$cmp.hideTitle ? api_static_fragment($fragment4, 11, [api_static_part(1, null, api_dynamic_text(jpNewsItem.title))]) : null, !$cmp.hideTitle ? api_static_fragment($fragment5, 13, [api_static_part(1, null, api_dynamic_text(jpNewsItem.title))]) : null, api_custom_element("wds-link", _wdsLink, {
      classMap: stc2,
      props: {
        "target": "_blank",
        "i18nMessage": jpNewsItem.text
      },
      key: 14
    })]) : null;
  }), $cmp.hideTitle ? api_static_fragment($fragment6, 16, [api_static_part(1, null, api_dynamic_text($cmp.labels.getHelp.title))]) : null, !$cmp.hideTitle ? api_static_fragment($fragment7, 18, [api_static_part(1, null, api_dynamic_text($cmp.labels.getHelp.title))]) : null, api_element("div", stc4, [api_element("div", stc5, [api_custom_element("ax-icon", _axIcon, stc6), api_custom_element("wds-link", _wdsLink, stc7, [api_static_fragment($fragment8, 24, [api_static_part(2, null, api_dynamic_text($cmp.labels.getHelp.supportLink))])])]), !$cmp.isJapaneseUserLanguage ? api_element("div", stc8, [api_custom_element("ax-icon", _axIcon, stc9), api_custom_element("wds-link", _wdsLink, stc10, [api_static_fragment($fragment9, 29, [api_static_part(2, null, api_dynamic_text($cmp.labels.getHelp.feedbackLink))])])]) : null])]))];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-4faa6lnq835";
tmpl.legacyStylesheetToken = "undefined-_helpCenterMobile";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
